(function() {
  'use strict';

  /* ========================================================================
     N701 Modular Sofa Configurator
     All steps visible on one page, Ethnicraft-inspired UX
     ======================================================================== */

  var COLOR_HEX = {
    'Beige':              '#d4c4a8',
    'Blue':               '#7b96b5',
    'Dark Grey':          '#5a5a5a',
    'Ecru Eco':           '#e8dfd0',
    'Graphite Eco':       '#4a4a4a',
    'Moss Eco':           '#6b7c5e',
    'Chestnut Leather':   '#6b3a2a',
    'Old Saddle Leather': '#8b6543'
  };

  var COLOR_CATEGORIES = [
    { label: 'Fabric', colors: ['Beige', 'Blue', 'Dark Grey'] },
    { label: 'Eco Fabric', colors: ['Ecru Eco', 'Graphite Eco', 'Moss Eco'] },
    { label: 'Leather', colors: ['Chestnut Leather', 'Old Saddle Leather'] }
  ];

  /* ---------- Module dimensions (inches / cm) ---------- */

  var MODULE_DIMENSIONS = {
    '1 Seater':          { w: 31.5, d: 36, h: 30 },
    '2 Seater':          { w: 55.5, d: 36, h: 30 },
    '3 Seater':          { w: 83,   d: 36, h: 30 },
    '45\u00b0 Round Corner':  { w: 36,   d: 36, h: 30 },
    '90\u00b0 Square Corner': { w: 36,   d: 36, h: 30 },
    '90\u00b0 Round Corner':  { w: 47.2, d: 47.2, h: 30 },
    'Footstool':         { w: 28,   d: 28, h: 17 }
  };

  var MODULE_DIMENSIONS_CM = {
    '1 Seater':          { w: 80,  d: 91,  h: 76 },
    '2 Seater':          { w: 140, d: 91,  h: 76 },
    '3 Seater':          { w: 210, d: 91,  h: 76 },
    '45\u00b0 Round Corner':  { w: 91,  d: 91,  h: 76 },
    '90\u00b0 Square Corner': { w: 91,  d: 91,  h: 76 },
    '90\u00b0 Round Corner':  { w: 120, d: 120, h: 76 },
    'Footstool':         { w: 70,  d: 70,  h: 43 }
  };

  /* ---------- Shape groups (one card per shape) ---------- */

  var SHAPE_GROUPS = [
    { shapeKey: 'straight', name: 'Straight', seats: 3, hasCorner: false, hasFootstool: false },
    { shapeKey: 'l-3',      name: 'L-Shape',  seats: 3, hasCorner: true,  hasFootstool: false },
    { shapeKey: 'l-4',      name: 'L-Shape',  seats: 4, hasCorner: true,  hasFootstool: false },
    { shapeKey: 'l-5',      name: 'L-Shape',  seats: 5, hasCorner: true,  hasFootstool: false },
    { shapeKey: 'l-5-ottoman', name: 'L + Ottoman', seats: 5, hasCorner: true, hasFootstool: true },
    { shapeKey: 'l-6-ottoman', name: 'L + Ottoman', seats: 6, hasCorner: true, hasFootstool: true },
    { shapeKey: 'u-6',      name: 'U-Shape',  seats: 6, hasCorner: true,  hasFootstool: false }
  ];

  /* ---------- Layout definitions ---------- */

  var LAYOUTS = [
    { id: 'straight-3', name: 'Straight', seats: 3, cornerType: null, modules: ['1 Seater', '2 Seater'], hasFootstool: false, shapeKey: 'straight' },
    { id: 'l-3-square', name: 'L-Shape', seats: 3, cornerType: 'square', modules: ['1 Seater', '90\u00b0 Square Corner', '1 Seater'], hasFootstool: false, shapeKey: 'l-3' },
    { id: 'l-3-round', name: 'L-Shape', seats: 3, cornerType: 'round', modules: ['1 Seater', '90\u00b0 Round Corner', '1 Seater'], hasFootstool: false, shapeKey: 'l-3' },
    { id: 'l-4-square', name: 'L-Shape', seats: 4, cornerType: 'square', modules: ['1 Seater', '90\u00b0 Square Corner', '2 Seater'], hasFootstool: false, shapeKey: 'l-4' },
    { id: 'l-4-round', name: 'L-Shape', seats: 4, cornerType: 'round', modules: ['1 Seater', '90\u00b0 Round Corner', '2 Seater'], hasFootstool: false, shapeKey: 'l-4' },
    { id: 'l-5-square', name: 'L-Shape', seats: 5, cornerType: 'square', modules: ['1 Seater', '90\u00b0 Square Corner', '3 Seater'], hasFootstool: false, shapeKey: 'l-5' },
    { id: 'l-5-round', name: 'L-Shape', seats: 5, cornerType: 'round', modules: ['1 Seater', '90\u00b0 Round Corner', '3 Seater'], hasFootstool: false, shapeKey: 'l-5' },
    { id: 'l-5-ottoman-square', name: 'L + Ottoman', seats: 5, cornerType: 'square', modules: ['1 Seater', '90\u00b0 Square Corner', '2 Seater', 'Footstool'], hasFootstool: true, shapeKey: 'l-5-ottoman' },
    { id: 'l-5-ottoman-round', name: 'L + Ottoman', seats: 5, cornerType: 'round', modules: ['1 Seater', '90\u00b0 Round Corner', '2 Seater', 'Footstool'], hasFootstool: true, shapeKey: 'l-5-ottoman' },
    { id: 'l-6-ottoman-square', name: 'L + Ottoman', seats: 6, cornerType: 'square', modules: ['1 Seater', '90\u00b0 Square Corner', '3 Seater', 'Footstool'], hasFootstool: true, shapeKey: 'l-6-ottoman' },
    { id: 'l-6-ottoman-round', name: 'L + Ottoman', seats: 6, cornerType: 'round', modules: ['1 Seater', '90\u00b0 Round Corner', '3 Seater', 'Footstool'], hasFootstool: true, shapeKey: 'l-6-ottoman' },
    { id: 'u-6-square', name: 'U-Shape', seats: 6, cornerType: 'square', modules: ['1 Seater', '90\u00b0 Square Corner', '2 Seater', '90\u00b0 Square Corner', '1 Seater'], hasFootstool: false, shapeKey: 'u-6' },
    { id: 'u-6-round', name: 'U-Shape', seats: 6, cornerType: 'round', modules: ['1 Seater', '90\u00b0 Round Corner', '2 Seater', '90\u00b0 Round Corner', '1 Seater'], hasFootstool: false, shapeKey: 'u-6' }
  ];

  /* ---------- SVG shape definitions ---------- */

  var SHAPE_DEFS = {
    'straight': { rects: [{ x: 0, y: 0, w: 80, h: 65 }, { x: 86, y: 0, w: 120, h: 65 }], vw: 206, vh: 65 },
    'l-3':      { rects: [{ x: 0, y: 0, w: 65, h: 65 }, { x: 0, y: 71, w: 65, h: 65, isCorner: true }, { x: 71, y: 71, w: 65, h: 65 }], vw: 136, vh: 136 },
    'l-4':      { rects: [{ x: 0, y: 0, w: 65, h: 65 }, { x: 0, y: 71, w: 65, h: 65, isCorner: true }, { x: 71, y: 71, w: 120, h: 65 }], vw: 191, vh: 136 },
    'l-5':      { rects: [{ x: 0, y: 0, w: 65, h: 65 }, { x: 0, y: 71, w: 65, h: 65, isCorner: true }, { x: 71, y: 71, w: 160, h: 65 }], vw: 231, vh: 136 },
    'l-5-ottoman': { rects: [{ x: 0, y: 0, w: 65, h: 65 }, { x: 0, y: 71, w: 65, h: 65, isCorner: true }, { x: 71, y: 71, w: 120, h: 65 }, { x: 71, y: 146, w: 50, h: 40, isFootstool: true }], vw: 191, vh: 186 },
    'l-6-ottoman': { rects: [{ x: 0, y: 0, w: 65, h: 65 }, { x: 0, y: 71, w: 65, h: 65, isCorner: true }, { x: 71, y: 71, w: 160, h: 65 }, { x: 71, y: 146, w: 50, h: 40, isFootstool: true }], vw: 231, vh: 186 },
    'u-6':      { rects: [{ x: 0, y: 0, w: 65, h: 65 }, { x: 0, y: 71, w: 65, h: 65, isCorner: true }, { x: 71, y: 71, w: 120, h: 65 }, { x: 197, y: 71, w: 65, h: 65, isCorner: true }, { x: 197, y: 0, w: 65, h: 65 }], vw: 262, vh: 136 }
  };

  /* ---------- Utilities ---------- */

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = parseInt(cents, 10);
    var dollars = cents / 100;
    var amount = dollars.toFixed(2);
    var amountWithComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amountNoDecimals = Math.round(dollars).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (!format || format === '') format = '${{amount}}';
    return format
      .replace('{{amount_with_comma_separator}}', amountWithComma.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals.replace(',', '.'))
      .replace('{{amount}}', amountWithComma)
      .replace('{{amount_no_decimals}}', amountNoDecimals);
  }

  function renderSVG(shapeKey, options) {
    options = options || {};
    var shape = SHAPE_DEFS[shapeKey];
    if (!shape) return '';
    var pad = 6;
    var vw = shape.vw + pad * 2;
    var vh = shape.vh + pad * 2;
    var isRound = options.round === true;
    var mirrored = options.mirrored === true;
    var els = shape.rects.map(function(r) {
      var rx = r.x + pad;
      var ry = r.y + pad;
      if (r.isCorner && isRound) {
        var d = 'M ' + rx + ',' + ry +
                ' L ' + (rx + r.w) + ',' + ry +
                ' A ' + r.w + ',' + r.h + ' 0 0,1 ' + rx + ',' + (ry + r.h) +
                ' Z';
        return '<path d="' + d + '" fill="none" stroke="#333" stroke-width="1.5"/>';
      }
      var cr = r.isFootstool ? 2 : 3;
      return '<rect x="' + rx + '" y="' + ry + '" width="' + r.w + '" height="' + r.h + '" rx="' + cr + '" fill="none" stroke="#333" stroke-width="1.5"/>';
    }).join('');
    var mirror = mirrored ? ' style="transform:scaleX(-1);transform-origin:center"' : '';
    return '<svg viewBox="0 0 ' + vw + ' ' + vh + '" xmlns="http://www.w3.org/2000/svg"' + mirror + '>' + els + '</svg>';
  }

  var PERSON_ICON = '<svg width="12" height="12" viewBox="0 0 16 16" fill="#999"><circle cx="8" cy="4.5" r="2.5"/><ellipse cx="8" cy="13" rx="5" ry="3.5"/></svg>';

  /* ---------- Custom Builder module definitions ---------- */

  var CUSTOM_MODULES = [
    { type: '1 Seater',          label: '1 Seater',     isCorner: false, isFootstool: false },
    { type: '2 Seater',          label: '2 Seater',     isCorner: false, isFootstool: false },
    { type: '3 Seater',          label: '3 Seater',     isCorner: false, isFootstool: false },
    { type: '45\u00b0 Round Corner',  label: '45\u00b0 Corner',   isCorner: true,  isFootstool: false },
    { type: '90\u00b0 Square Corner', label: 'Square Corner', isCorner: true,  isFootstool: false },
    { type: '90\u00b0 Round Corner',  label: 'Round Corner',  isCorner: true,  isFootstool: false },
    { type: 'Footstool',         label: 'Footstool',    isCorner: false, isFootstool: true  }
  ];

  /* ---------- Main Configurator ---------- */

  function SofaConfigurator(sectionId) {
    this.sectionId = sectionId;
    this.data = window.__SOFA_CONFIGURATOR__[sectionId];
    if (!this.data) return;
    this.container = document.getElementById('SofaConfigurator-' + sectionId);
    if (!this.container) return;

    this.selectedColor = null;
    this.selectedShapeKey = null;
    this.selectedCornerType = 'square';
    this.orientation = 'left';

    this.mode = 'custom';
    this.customModules = [];
    this.customIdCounter = 0;

    this.init();
  }

  SofaConfigurator.prototype.init = function() {
    if (this.data.enableCustomBuilder) this.renderModeToggle();
    this.renderLayouts();
    this.renderSwatches();
    this.bindGallery();
    if (this.data.enableCustomBuilder && this.mode === 'custom') {
      var layoutsEl = document.getElementById('Layouts-' + this.sectionId);
      var customEl = document.getElementById('CustomBuilder-' + this.sectionId);
      if (layoutsEl) layoutsEl.style.display = 'none';
      if (customEl) { customEl.style.display = ''; this.renderCustomBuilder(); }
    }
  };

  /* -- Derived layout from shape + corner type -- */

  SofaConfigurator.prototype.getSelectedLayoutId = function() {
    if (!this.selectedShapeKey) return null;
    if (this.selectedShapeKey === 'straight') return 'straight-3';
    return this.selectedShapeKey + '-' + this.selectedCornerType;
  };

  SofaConfigurator.prototype.getSelectedLayout = function() {
    if (this.mode === 'custom') return this.getCustomLayout();
    var id = this.getSelectedLayoutId();
    return id ? this.getLayout(id) : null;
  };

  /* ---------- Gallery ---------- */

  SofaConfigurator.prototype.bindGallery = function() {
    var thumbContainer = this.container.querySelector('.configurator__gallery-thumbs');
    if (!thumbContainer) return;
    this.bindThumbClicks(thumbContainer);
  };

  SofaConfigurator.prototype.bindThumbClicks = function(thumbContainer) {
    var mainImg = document.getElementById('GalleryMain-' + this.sectionId);
    if (!mainImg || !thumbContainer) return;
    thumbContainer.querySelectorAll('.configurator__gallery-thumb').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        mainImg.src = thumb.dataset.fullUrl;
        thumbContainer.querySelectorAll('.configurator__gallery-thumb').forEach(function(t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  };

  SofaConfigurator.prototype.updateGallery = function() {
    var mainImg = document.getElementById('GalleryMain-' + this.sectionId);
    var thumbContainer = this.container.querySelector('.configurator__gallery-thumbs');
    if (!mainImg || !thumbContainer) return;
    var images = this.data.productImages || [];
    if (!images.length) return;

    var layout = this.getSelectedLayout();
    var color = this.selectedColor;
    if (!color && !layout) return;

    var colorLower = color ? color.toLowerCase() : null;
    var moduleTerms = this.getLayoutModuleTerms(layout);
    var filtered = [];

    if (color) {
      filtered = images.filter(function(img) {
        return (img.alt || '').toLowerCase().indexOf(colorLower) !== -1;
      });
      if (layout && moduleTerms.length) {
        filtered.sort(function(a, b) {
          var altA = (a.alt || '').toLowerCase();
          var altB = (b.alt || '').toLowerCase();
          var scoreA = moduleTerms.some(function(t) { return altA.indexOf(t) !== -1; }) ? 0 : 1;
          var scoreB = moduleTerms.some(function(t) { return altB.indexOf(t) !== -1; }) ? 0 : 1;
          return scoreA - scoreB;
        });
      }
    } else if (layout && moduleTerms.length) {
      filtered = images.filter(function(img) {
        var alt = (img.alt || '').toLowerCase();
        return moduleTerms.some(function(t) { return alt.indexOf(t) !== -1; });
      });
    }

    if (!filtered.length) filtered = images;
    var thumbImages = filtered.slice(0, 20);
    mainImg.src = thumbImages[0].url;

    var html = '';
    thumbImages.forEach(function(img, i) {
      var activeClass = i === 0 ? ' is-active' : '';
      html += '<button class="configurator__gallery-thumb' + activeClass + '"';
      html += ' data-full-url="' + img.url + '"';
      html += ' type="button" aria-label="View image ' + (i + 1) + '">';
      html += '<img src="' + img.thumb + '" alt="' + (img.alt || '').replace(/"/g, '&quot;') + '" width="120" height="120" loading="lazy">';
      html += '</button>';
    });
    thumbContainer.innerHTML = html;
    this.bindThumbClicks(thumbContainer);
  };

  SofaConfigurator.prototype.getLayoutModuleTerms = function(layout) {
    if (!layout) return [];
    var terms = [];
    layout.modules.forEach(function(mod) {
      var lower = mod.toLowerCase();
      if (lower.indexOf('square corner') !== -1) terms.push('square corner');
      else if (lower.indexOf('round corner') !== -1) terms.push('round corner');
      else if (lower.indexOf('3 seater') !== -1) terms.push('3 seater');
      else if (lower.indexOf('2 seater') !== -1) terms.push('2 seater');
      else if (lower.indexOf('1 seater') !== -1) terms.push('1 seater');
      else if (lower === 'footstool') terms.push('footstool');
    });
    return terms;
  };

  /* ---------- Swatches ---------- */

  SofaConfigurator.prototype.calculateFootprint = function(layout) {
    if (!layout) return null;
    var modules = layout.modules;
    var totalW = 0, totalD = 0, totalW_cm = 0, totalD_cm = 0;

    if (layout.id === 'custom') {
      // Generic footprint for custom builds: measure from SVG layout data
      var corners = modules.filter(function(m) { return m.indexOf('Corner') !== -1; });
      if (corners.length === 0) {
        // Straight: sum widths
        modules.forEach(function(mod) {
          var dim = MODULE_DIMENSIONS[mod], dim_cm = MODULE_DIMENSIONS_CM[mod];
          if (dim) { totalW += dim.w; totalD = Math.max(totalD, dim.d); }
          if (dim_cm) { totalW_cm += dim_cm.w; totalD_cm = Math.max(totalD_cm, dim_cm.d); }
        });
        totalW += (modules.length - 1) * 2;
        totalW_cm += (modules.length - 1) * 5;
      } else {
        // L or U: compute from arm segments
        var firstCornerIdx = -1;
        for (var i = 0; i < modules.length; i++) { if (modules[i].indexOf('Corner') !== -1) { firstCornerIdx = i; break; } }
        var corner = modules[firstCornerIdx];
        var cDim = MODULE_DIMENSIONS[corner] || { w: 36, d: 36 };
        var cDim_cm = MODULE_DIMENSIONS_CM[corner] || { w: 91, d: 91 };
        // Horizontal arm: everything after first corner until next corner or end (excluding footstool)
        var secondCornerIdx = -1;
        for (var j = firstCornerIdx + 1; j < modules.length; j++) { if (modules[j].indexOf('Corner') !== -1) { secondCornerIdx = j; break; } }
        var hEnd = secondCornerIdx > -1 ? secondCornerIdx : modules.length;
        totalW = cDim.w; totalW_cm = cDim_cm.w;
        for (var k = firstCornerIdx + 1; k < hEnd; k++) {
          if (modules[k] === 'Footstool') continue;
          var d = MODULE_DIMENSIONS[modules[k]], dc = MODULE_DIMENSIONS_CM[modules[k]];
          if (d) totalW += d.w + 2;
          if (dc) totalW_cm += dc.w + 5;
        }
        if (secondCornerIdx > -1) {
          var c2 = MODULE_DIMENSIONS[modules[secondCornerIdx]] || { w: 36 };
          var c2c = MODULE_DIMENSIONS_CM[modules[secondCornerIdx]] || { w: 91 };
          totalW += c2.w + 2; totalW_cm += c2c.w + 5;
        }
        // Vertical arm: everything before first corner
        totalD = cDim.d; totalD_cm = cDim_cm.d;
        for (var m = 0; m < firstCornerIdx; m++) {
          if (modules[m] === 'Footstool') continue;
          var dd = MODULE_DIMENSIONS[modules[m]], ddc = MODULE_DIMENSIONS_CM[modules[m]];
          if (dd) totalD += dd.d + 2;
          if (ddc) totalD_cm += ddc.d + 5;
        }
        // Footstool adds depth
        if (modules.indexOf('Footstool') > -1) {
          var fsDim = MODULE_DIMENSIONS['Footstool'], fsDim_cm = MODULE_DIMENSIONS_CM['Footstool'];
          if (fsDim) totalD += fsDim.d + 4;
          if (fsDim_cm) totalD_cm += fsDim_cm.d + 10;
        }
      }
      if (totalW === 0) return null;
      return { w_in: Math.round(totalW * 10) / 10, d_in: Math.round(totalD * 10) / 10, w_cm: Math.round(totalW_cm), d_cm: Math.round(totalD_cm) };
    }

    if (layout.shapeKey === 'straight') {
      modules.forEach(function(mod) {
        var dim = MODULE_DIMENSIONS[mod], dim_cm = MODULE_DIMENSIONS_CM[mod];
        if (dim) { totalW += dim.w; totalD = Math.max(totalD, dim.d); }
        if (dim_cm) { totalW_cm += dim_cm.w; totalD_cm = Math.max(totalD_cm, dim_cm.d); }
      });
      totalW += (modules.length - 1) * 2;
      totalW_cm += (modules.length - 1) * 5;
    } else if (layout.shapeKey.startsWith('l-') && !layout.shapeKey.includes('ottoman')) {
      var corner = modules.find(function(m) { return m.indexOf('Corner') !== -1; });
      var cDim = corner ? MODULE_DIMENSIONS[corner] : { w: 36, d: 36 };
      var cDim_cm = corner ? MODULE_DIMENSIONS_CM[corner] : { w: 91, d: 91 };
      var hArm = modules.slice(modules.indexOf(corner) + 1);
      totalW = cDim.w; totalW_cm = cDim_cm.w;
      hArm.forEach(function(mod) { var d = MODULE_DIMENSIONS[mod], dc = MODULE_DIMENSIONS_CM[mod]; if (d) totalW += d.w + 2; if (dc) totalW_cm += dc.w + 5; });
      var vArm = modules.slice(0, modules.indexOf(corner));
      totalD = cDim.d; totalD_cm = cDim_cm.d;
      vArm.forEach(function(mod) { var d = MODULE_DIMENSIONS[mod], dc = MODULE_DIMENSIONS_CM[mod]; if (d) totalD += d.d + 2; if (dc) totalD_cm += dc.d + 5; });
    } else if (layout.shapeKey.includes('ottoman')) {
      var corner = modules.find(function(m) { return m.indexOf('Corner') !== -1; });
      var cDim = corner ? MODULE_DIMENSIONS[corner] : { w: 36, d: 36 };
      var cDim_cm = corner ? MODULE_DIMENSIONS_CM[corner] : { w: 91, d: 91 };
      var footIdx = modules.indexOf('Footstool');
      var mainMods = footIdx > -1 ? modules.slice(0, footIdx) : modules;
      var hArm = mainMods.slice(mainMods.indexOf(corner) + 1);
      totalW = cDim.w; totalW_cm = cDim_cm.w;
      hArm.forEach(function(mod) { var d = MODULE_DIMENSIONS[mod], dc = MODULE_DIMENSIONS_CM[mod]; if (d) totalW += d.w + 2; if (dc) totalW_cm += dc.w + 5; });
      var vArm = mainMods.slice(0, mainMods.indexOf(corner));
      totalD = cDim.d; totalD_cm = cDim_cm.d;
      vArm.forEach(function(mod) { var d = MODULE_DIMENSIONS[mod], dc = MODULE_DIMENSIONS_CM[mod]; if (d) totalD += d.d + 2; if (dc) totalD_cm += dc.d + 5; });
      var fsDim = MODULE_DIMENSIONS['Footstool'], fsDim_cm = MODULE_DIMENSIONS_CM['Footstool'];
      if (fsDim) totalD += fsDim.d + 4;
      if (fsDim_cm) totalD_cm += fsDim_cm.d + 10;
    } else if (layout.shapeKey === 'u-6') {
      var corners = modules.filter(function(m) { return m.indexOf('Corner') !== -1; });
      var firstCornerIdx = modules.indexOf(corners[0]);
      var secondCornerIdx = modules.lastIndexOf(corners[1] || corners[0]);
      var centerMods = modules.slice(firstCornerIdx + 1, secondCornerIdx);
      var c0 = MODULE_DIMENSIONS[corners[0]] || { w: 36, d: 36 };
      var c0_cm = MODULE_DIMENSIONS_CM[corners[0]] || { w: 91, d: 91 };
      totalW = c0.w; totalW_cm = c0_cm.w;
      centerMods.forEach(function(mod) { var d = MODULE_DIMENSIONS[mod], dc = MODULE_DIMENSIONS_CM[mod]; if (d) totalW += d.w + 2; if (dc) totalW_cm += dc.w + 5; });
      totalW += c0.w + 2; totalW_cm += c0_cm.w + 5;
      var vArm = modules.slice(0, firstCornerIdx);
      totalD = c0.d; totalD_cm = c0_cm.d;
      vArm.forEach(function(mod) { var d = MODULE_DIMENSIONS[mod], dc = MODULE_DIMENSIONS_CM[mod]; if (d) totalD += d.d + 2; if (dc) totalD_cm += dc.d + 5; });
    }

    if (totalW === 0) return null;
    return { w_in: Math.round(totalW * 10) / 10, d_in: Math.round(totalD * 10) / 10, w_cm: Math.round(totalW_cm), d_cm: Math.round(totalD_cm) };
  };

  SofaConfigurator.prototype.renderSwatches = function() {
    var self = this;
    var container = document.getElementById('Swatches-' + this.sectionId);
    if (!container) return;
    var availableColors = {};
    this.data.variants.forEach(function(v) { if (!availableColors[v.option1]) availableColors[v.option1] = true; });

    var html = '';
    COLOR_CATEGORIES.forEach(function(cat, catIdx) {
      var hasColors = cat.colors.some(function(c) { return availableColors[c]; });
      if (!hasColors) return;
      if (catIdx > 0) html += '<div class="configurator__swatch-divider"></div>';
      html += '<div class="configurator__swatch-group">';
      html += '<div class="configurator__swatch-group-label">' + cat.label + '</div>';
      html += '<div class="configurator__swatch-group-colors">';
      cat.colors.forEach(function(color) {
        if (!availableColors[color]) return;
        var hex = COLOR_HEX[color] || '#ccc';
        var displayColor = color.replace(' Eco', '').replace(' Leather', '');
        html += '<button class="configurator__swatch" data-color="' + color + '" type="button" aria-label="' + color + '" title="' + displayColor + '">';
        html += '<span class="configurator__swatch-circle" style="background-color: ' + hex + ';"></span>';
        html += '<span class="configurator__swatch-name">' + displayColor + '</span>';
        html += '</button>';
      });
      html += '</div></div>';
    });

    container.innerHTML = html;
    container.querySelectorAll('.configurator__swatch').forEach(function(btn) {
      btn.addEventListener('click', function() { self.selectColor(btn.dataset.color); });
    });
  };

  SofaConfigurator.prototype.selectColor = function(color) {
    this.selectedColor = color;
    this.container.querySelectorAll('.configurator__swatch').forEach(function(btn) {
      btn.classList.toggle('is-selected', btn.dataset.color === color);
    });
    var nameEl = document.getElementById('ColorName-' + this.sectionId);
    if (nameEl) nameEl.textContent = color;
    if (this.mode === 'custom') {
      this.renderModulePalette();
      this.renderBuildStrip();
      this.validateCustomBuild();
    } else {
      this.renderLayouts();
    }
    this.updateGallery();
    this.updateSummary();
  };

  /* ---------- Layouts ---------- */

  SofaConfigurator.prototype.getLayout = function(id) {
    return LAYOUTS.find(function(l) { return l.id === id; });
  };

  SofaConfigurator.prototype.getVariant = function(color, module) {
    return this.data.variants.find(function(v) { return v.option1 === color && v.option2 === module; });
  };

  SofaConfigurator.prototype.getFootstoolVariant = function(color) {
    return this.data.footstoolVariants.find(function(v) { return v.option1 === color; });
  };

  SofaConfigurator.prototype.isLayoutAvailable = function(layout, color) {
    var self = this;
    var c = color || this.selectedColor;
    if (!c) return true;
    return layout.modules.every(function(mod) {
      if (mod === 'Footstool') return !!self.getFootstoolVariant(c);
      var v = self.getVariant(c, mod);
      return v && v.available;
    });
  };

  SofaConfigurator.prototype.calculatePrice = function(layout, color) {
    var self = this;
    var c = color || this.selectedColor;
    if (!c) return null;
    var total = 0, valid = true;
    layout.modules.forEach(function(mod) {
      if (mod === 'Footstool') { var fv = self.getFootstoolVariant(c); if (fv) total += fv.price; else valid = false; }
      else { var v = self.getVariant(c, mod); if (v) total += v.price; else valid = false; }
    });
    return valid ? total : null;
  };

  SofaConfigurator.prototype.calculateFromPrice = function(layout) {
    var self = this;
    var allColors = [];
    this.data.variants.forEach(function(v) { if (allColors.indexOf(v.option1) === -1) allColors.push(v.option1); });
    var minPrice = null;
    allColors.forEach(function(color) {
      var price = self.calculatePrice(layout, color);
      if (price !== null && (minPrice === null || price < minPrice)) minPrice = price;
    });
    return minPrice;
  };

  /* ---------- Render layouts (7 unique shapes) ---------- */

  SofaConfigurator.prototype.renderLayouts = function() {
    var self = this;
    var container = document.getElementById('Layouts-' + this.sectionId);
    if (!container) return;
    var showFootstool = this.data.showFootstool !== false;
    var hasColor = !!this.selectedColor;

    var html = '';
    SHAPE_GROUPS.forEach(function(shape) {
      if (shape.hasFootstool && !showFootstool) return;

      // Use square variant for pricing display
      var layoutId = shape.shapeKey === 'straight' ? 'straight-3' : shape.shapeKey + '-square';
      var layout = self.getLayout(layoutId);
      if (!layout) return;

      var isSelected = self.selectedShapeKey === shape.shapeKey;
      var unavailable = hasColor && !self.isLayoutAvailable(layout);
      var classes = 'configurator__layout-card';
      if (isSelected) classes += ' is-selected';
      if (unavailable) classes += ' is-unavailable';

      html += '<div class="' + classes + '" data-shape-key="' + shape.shapeKey + '" role="button" tabindex="0">';

      // SVG diagram — reflects current corner type and flips with orientation
      var isRound = shape.hasCorner && self.selectedCornerType === 'round';
      var isMirrored = self.orientation === 'right' && shape.hasCorner && shape.shapeKey !== 'u-6';
      html += '<div class="configurator__svg-wrap">';
      html += renderSVG(shape.shapeKey, { round: isRound, mirrored: isMirrored });
      html += '</div>';

      // Layout name
      html += '<div class="configurator__layout-name">' + shape.name + '</div>';

      // Seat count badge
      html += '<div class="configurator__layout-seats">';
      html += PERSON_ICON;
      html += '<span>' + shape.seats + '</span>';
      html += '</div>';

      // Price
      if (unavailable) {
        html += '<div class="configurator__layout-price" style="color:#a33;">Unavailable</div>';
      } else if (hasColor) {
        var priceLayout = self.getLayout(shape.shapeKey === 'straight' ? 'straight-3' : shape.shapeKey + '-' + self.selectedCornerType) || layout;
        var price = self.calculatePrice(priceLayout);
        if (price !== null) html += '<div class="configurator__layout-price">' + formatMoney(price, self.data.moneyFormat) + '</div>';
      } else {
        var fromPrice = self.calculateFromPrice(layout);
        if (fromPrice !== null) html += '<div class="configurator__layout-price">From ' + formatMoney(fromPrice, self.data.moneyFormat) + '</div>';
      }

      html += '</div>';
    });

    container.innerHTML = html;

    container.querySelectorAll('.configurator__layout-card').forEach(function(card) {
      var handler = function() {
        if (card.classList.contains('is-unavailable')) return;
        self.selectShape(card.dataset.shapeKey);
      };
      card.addEventListener('click', handler);
      card.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handler(); }
      });
    });
  };

  SofaConfigurator.prototype.selectShape = function(shapeKey) {
    this.selectedShapeKey = shapeKey;

    this.container.querySelectorAll('.configurator__layout-card').forEach(function(card) {
      card.classList.toggle('is-selected', card.dataset.shapeKey === shapeKey);
    });

    this.renderOptions();
    this.updateGallery();
    this.updateSummary();

    // Flash the color picker if no color selected yet
    if (!this.selectedColor) {
      var picker = this.container.querySelector('.configurator__color-picker');
      if (picker) {
        picker.classList.add('is-highlight');
        setTimeout(function() { picker.classList.remove('is-highlight'); }, 1500);
      }
    }
  };

  /* ---------- Options (Corner Type + Orientation) ---------- */

  SofaConfigurator.prototype.renderOptions = function() {
    var optionsContainer = document.getElementById('Options-' + this.sectionId);
    if (!optionsContainer) return;

    var self = this;
    var shape = null;
    for (var i = 0; i < SHAPE_GROUPS.length; i++) {
      if (SHAPE_GROUPS[i].shapeKey === this.selectedShapeKey) { shape = SHAPE_GROUPS[i]; break; }
    }

    if (!shape || !shape.hasCorner) {
      optionsContainer.style.display = 'none';
      return;
    }

    optionsContainer.style.display = '';
    var isLShape = shape.shapeKey.startsWith('l-');
    var html = '';

    // Corner type toggle
    html += '<div class="configurator__option-group">';
    html += '<span class="configurator__option-label">Corner Style</span>';
    html += '<div class="configurator__option-toggle">';
    html += '<button class="configurator__option-btn' + (this.selectedCornerType === 'square' ? ' is-active' : '') + '" data-corner="square" type="button">';
    html += '<span class="configurator__option-preview">' + renderSVG(shape.shapeKey, { round: false }) + '</span> Square</button>';
    html += '<button class="configurator__option-btn' + (this.selectedCornerType === 'round' ? ' is-active' : '') + '" data-corner="round" type="button">';
    html += '<span class="configurator__option-preview">' + renderSVG(shape.shapeKey, { round: true }) + '</span> Round</button>';
    html += '</div></div>';

    // Orientation toggle (L-shapes only, not U-shape)
    if (isLShape) {
      html += '<div class="configurator__option-group">';
      html += '<span class="configurator__option-label">Orientation</span>';
      html += '<div class="configurator__option-toggle">';
      html += '<button class="configurator__option-btn' + (this.orientation === 'left' ? ' is-active' : '') + '" data-orientation="left" type="button">';
      html += '<span class="configurator__option-preview">' + renderSVG(shape.shapeKey, { round: this.selectedCornerType === 'round' }) + '</span> Left</button>';
      html += '<button class="configurator__option-btn' + (this.orientation === 'right' ? ' is-active' : '') + '" data-orientation="right" type="button">';
      html += '<span class="configurator__option-preview">' + renderSVG(shape.shapeKey, { round: this.selectedCornerType === 'round', mirrored: true }) + '</span> Right</button>';
      html += '</div></div>';
    }

    optionsContainer.innerHTML = html;

    // Bind corner type buttons
    optionsContainer.querySelectorAll('[data-corner]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        self.selectedCornerType = btn.dataset.corner;
        self.renderOptions();
        self.renderLayouts();
        self.updateGallery();
        self.updateSummary();
      });
    });


    // Bind orientation buttons
    optionsContainer.querySelectorAll('[data-orientation]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        self.orientation = btn.dataset.orientation;
        self.renderOptions();
        self.renderLayouts();
        self.updateSummary();
      });
    });
  };

  /* ---------- Summary ---------- */

  SofaConfigurator.prototype.updateSummary = function() {
    var summarySection = document.getElementById('StepSummary-' + this.sectionId);
    var summaryContainer = document.getElementById('Summary-' + this.sectionId);
    if (!summarySection || !summaryContainer) return;

    var layout = this.getSelectedLayout();
    if (!layout || !this.selectedColor) {
      summarySection.style.display = 'none';
      return;
    }

    summarySection.style.display = '';
    var self = this;
    var colorHex = COLOR_HEX[this.selectedColor] || '#ccc';
    var mirrored = this.orientation === 'right';
    var totalPrice = 0;

    var modulesHtml = '';
    layout.modules.forEach(function(mod) {
      var variant, displayName;
      if (mod === 'Footstool') { variant = self.getFootstoolVariant(self.selectedColor); displayName = 'N701 Footstool'; }
      else { variant = self.getVariant(self.selectedColor, mod); displayName = 'N701 ' + mod; }
      if (variant) {
        totalPrice += variant.price;
        modulesHtml += '<li class="configurator__summary-module">';
        modulesHtml += '<span class="configurator__summary-module-name">' + displayName + '</span>';
        modulesHtml += '<span class="configurator__summary-module-price">' + formatMoney(variant.price, self.data.moneyFormat) + '</span>';
        modulesHtml += '</li>';
      }
    });

    var html = '';
    html += '<div class="configurator__summary-diagram">';
    if (this.mode === 'custom') {
      var svgData = this.computeCustomSVGLayout();
      html += svgData ? this.renderCustomSVG(svgData) : '';
    } else {
      html += renderSVG(layout.shapeKey, { round: layout.cornerType === 'round', mirrored: mirrored });
    }
    html += '</div>';

    html += '<div class="configurator__summary-details">';

    html += '<div class="configurator__summary-color">';
    html += '<span class="configurator__summary-color-circle" style="background-color: ' + colorHex + ';"></span>';
    html += '<span>' + this.selectedColor + '</span>';
    html += '</div>';

    var label;
    if (layout.id === 'custom') {
      label = 'Custom Build \u00b7 ' + layout.modules.length + ' Modules';
      if (layout.seats > 0) label += ' \u00b7 ' + layout.seats + ' Seats';
    } else {
      label = layout.name;
      if (layout.cornerType) label += ' \u00b7 ' + (layout.cornerType === 'square' ? 'Square Corner' : 'Round Corner');
      label += ' \u00b7 ' + layout.seats + ' Seats';
      if (mirrored && layout.cornerType && !layout.id.startsWith('u-')) label += ' \u00b7 Right';
    }
    html += '<div class="configurator__summary-layout-name">' + label + '</div>';

    var footprint = this.calculateFootprint(layout);
    if (footprint) {
      html += '<div class="configurator__summary-dimensions">';
      html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 3H3v18"/></svg>';
      html += '<span>Total footprint: ' + footprint.w_in + '\u2033 W \u00d7 ' + footprint.d_in + '\u2033 D';
      html += ' <span class="configurator__dims-cm">(' + footprint.w_cm + ' \u00d7 ' + footprint.d_cm + ' cm)</span></span></div>';
    }

    html += '<ul class="configurator__summary-modules">' + modulesHtml + '</ul>';

    html += '<div class="configurator__summary-total"><span>Total</span><span>' + formatMoney(totalPrice, this.data.moneyFormat) + '</span></div>';

    var monthlyPayment = Math.round(totalPrice / 100 / 12);
    if (monthlyPayment > 0) {
      html += '<div class="configurator__financing-teaser">As low as <strong>$' + monthlyPayment + '/mo</strong> with <span class="configurator__shop-pay">Shop Pay Installments</span></div>';
    }

    html += '<button class="configurator__add-to-cart" type="button" id="AddToCart-' + this.sectionId + '">Add Configuration to Cart</button>';

    html += '<div class="configurator__trust-bar">';
    html += '<div class="configurator__trust-item"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="1" y="6" width="22" height="13" rx="2"/><path d="M1 10h22"/></svg><span>Free Shipping Over $999</span></div>';
    html += '<div class="configurator__trust-item"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/></svg><span>5-Year Frame Warranty</span></div>';
    html += '<div class="configurator__trust-item"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 10h4l3-7 3 7h4l-3.5 4 1.5 6-5-3.5L4.5 20l1.5-6L3 10z"/></svg><span>30-Day Returns</span></div>';
    html += '</div>';

    html += '</div>';

    summaryContainer.innerHTML = html;
    var addBtn = document.getElementById('AddToCart-' + this.sectionId);
    if (addBtn) addBtn.addEventListener('click', function() { self.addToCart(); });
  };

  /* ---------- Custom Builder: Mode Toggle ---------- */

  SofaConfigurator.prototype.renderModeToggle = function() {
    var self = this;
    var el = document.getElementById('ModeToggle-' + this.sectionId);
    if (!el) return;
    var html = '<div class="configurator__mode-tabs">';
    html += '<button class="configurator__mode-tab' + (this.mode === 'preset' ? ' is-active' : '') + '" data-mode="preset" type="button">Choose a Layout</button>';
    html += '<button class="configurator__mode-tab' + (this.mode === 'custom' ? ' is-active' : '') + '" data-mode="custom" type="button">Build Your Own</button>';
    html += '</div>';
    el.innerHTML = html;
    el.querySelectorAll('.configurator__mode-tab').forEach(function(btn) {
      btn.addEventListener('click', function() { self.setMode(btn.dataset.mode); });
    });
  };

  SofaConfigurator.prototype.setMode = function(mode) {
    if (this.mode === mode) return;
    this.mode = mode;
    var layoutsEl = document.getElementById('Layouts-' + this.sectionId);
    var customEl = document.getElementById('CustomBuilder-' + this.sectionId);
    var optionsEl = document.getElementById('Options-' + this.sectionId);
    if (mode === 'custom') {
      if (layoutsEl) layoutsEl.style.display = 'none';
      if (optionsEl) optionsEl.style.display = 'none';
      if (customEl) { customEl.style.display = ''; this.renderCustomBuilder(); }
    } else {
      if (layoutsEl) layoutsEl.style.display = '';
      if (customEl) customEl.style.display = 'none';
      this.renderOptions();
    }
    this.renderModeToggle();
    this.updateSummary();
  };

  /* ---------- Custom Builder: Module Palette ---------- */

  SofaConfigurator.prototype.renderCustomBuilder = function() {
    var el = document.getElementById('CustomBuilder-' + this.sectionId);
    if (!el) return;
    var html = '';
    html += '<div class="custom-builder__palette" id="Palette-' + this.sectionId + '"></div>';
    html += '<div class="custom-builder__strip" id="BuildStrip-' + this.sectionId + '"></div>';
    html += '<div class="custom-builder__preview" id="CustomPreview-' + this.sectionId + '"></div>';
    html += '<div class="custom-builder__warnings" id="CustomWarnings-' + this.sectionId + '"></div>';
    el.innerHTML = html;
    this.renderModulePalette();
    this.renderBuildStrip();
    this.renderCustomPreview();
    this.validateCustomBuild();
  };

  SofaConfigurator.prototype.renderModuleMiniSVG = function(type) {
    var pad = 4;
    if (type === '1 Seater') return '<svg viewBox="0 0 48 44" xmlns="http://www.w3.org/2000/svg"><rect x="' + pad + '" y="' + pad + '" width="40" height="36" rx="3" fill="none" stroke="#333" stroke-width="1.5"/></svg>';
    if (type === '2 Seater') return '<svg viewBox="0 0 72 44" xmlns="http://www.w3.org/2000/svg"><rect x="' + pad + '" y="' + pad + '" width="64" height="36" rx="3" fill="none" stroke="#333" stroke-width="1.5"/></svg>';
    if (type === '3 Seater') return '<svg viewBox="0 0 96 44" xmlns="http://www.w3.org/2000/svg"><rect x="' + pad + '" y="' + pad + '" width="88" height="36" rx="3" fill="none" stroke="#333" stroke-width="1.5"/></svg>';
    if (type === '45\u00b0 Round Corner') {
      var x = pad, y = pad, w = 44, h = 44;
      var d45 = 'M ' + x + ',' + y + ' L ' + (x + w) + ',' + y + ' A ' + (w * 2) + ',' + (h * 2) + ' 0 0,1 ' + x + ',' + (y + h) + ' Z';
      return '<svg viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg"><path d="' + d45 + '" fill="none" stroke="#333" stroke-width="1.5"/></svg>';
    }
    if (type === '90\u00b0 Square Corner') return '<svg viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg"><rect x="' + pad + '" y="' + pad + '" width="44" height="44" rx="3" fill="none" stroke="#333" stroke-width="1.5"/></svg>';
    if (type === '90\u00b0 Round Corner') {
      var x = pad, y = pad, w = 44, h = 44;
      var d = 'M ' + x + ',' + y + ' L ' + (x + w) + ',' + y + ' A ' + w + ',' + h + ' 0 0,1 ' + x + ',' + (y + h) + ' Z';
      return '<svg viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg"><path d="' + d + '" fill="none" stroke="#333" stroke-width="1.5"/></svg>';
    }
    if (type === 'Footstool') return '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><rect x="' + pad + '" y="' + pad + '" width="36" height="36" rx="2" fill="none" stroke="#333" stroke-width="1.5" stroke-dasharray="4 2"/></svg>';
    return '';
  };

  SofaConfigurator.prototype.getModulePrice = function(type) {
    var self = this;
    var color = this.selectedColor;
    if (type === 'Footstool') {
      if (color) { var fv = this.getFootstoolVariant(color); return fv ? fv.price : null; }
      var minPrice = null;
      this.data.footstoolVariants.forEach(function(v) { if (minPrice === null || v.price < minPrice) minPrice = v.price; });
      return minPrice;
    }
    if (color) { var v = this.getVariant(color, type); return v ? v.price : null; }
    var allColors = [];
    this.data.variants.forEach(function(v) { if (allColors.indexOf(v.option1) === -1) allColors.push(v.option1); });
    var minPrice = null;
    allColors.forEach(function(c) { var v = self.getVariant(c, type); if (v && (minPrice === null || v.price < minPrice)) minPrice = v.price; });
    return minPrice;
  };

  SofaConfigurator.prototype.renderModulePalette = function() {
    var self = this;
    var el = document.getElementById('Palette-' + this.sectionId);
    if (!el) return;
    var showFootstool = this.data.showFootstool !== false;
    var hasColor = !!this.selectedColor;
    var cornerCount = this.customModules.filter(function(m) { return m.type.indexOf('Corner') !== -1; }).length;
    var footstoolCount = this.customModules.filter(function(m) { return m.type === 'Footstool'; }).length;
    var atMax = this.customModules.length >= 8;

    var html = '<div class="custom-builder__palette-grid">';
    CUSTOM_MODULES.forEach(function(mod) {
      if (mod.isFootstool && !showFootstool) return;
      var price = self.getModulePrice(mod.type);
      var disabled = atMax || (mod.isCorner && cornerCount >= 2) || (mod.isFootstool && footstoolCount >= 1);
      var cls = 'custom-builder__palette-card' + (disabled ? ' is-disabled' : '');

      html += '<div class="' + cls + '">';
      html += '<div class="custom-builder__palette-svg">' + self.renderModuleMiniSVG(mod.type) + '</div>';
      html += '<div class="custom-builder__palette-label">' + mod.label + '</div>';
      if (price !== null) {
        html += '<div class="custom-builder__palette-price">' + (hasColor ? '' : 'From ') + formatMoney(price, self.data.moneyFormat) + '</div>';
      }
      html += '<button class="custom-builder__palette-add" data-type="' + mod.type + '" type="button"' + (disabled ? ' disabled' : '') + '>+ Add</button>';
      html += '</div>';
    });
    html += '</div>';
    el.innerHTML = html;

    el.querySelectorAll('.custom-builder__palette-add').forEach(function(btn) {
      btn.addEventListener('click', function() { if (!btn.disabled) self.addCustomModule(btn.dataset.type); });
    });
  };

  /* ---------- Custom Builder: Build Strip ---------- */

  SofaConfigurator.prototype.addCustomModule = function(type) {
    if (this.customModules.length >= 8) return;
    this.customIdCounter++;
    this.customModules.push({ id: 'mod-' + this.customIdCounter, type: type });
    this.onCustomChange();
  };

  SofaConfigurator.prototype.removeCustomModule = function(id) {
    this.customModules = this.customModules.filter(function(m) { return m.id !== id; });
    this.onCustomChange();
  };

  SofaConfigurator.prototype.moveCustomModule = function(id, dir) {
    var idx = -1;
    for (var i = 0; i < this.customModules.length; i++) { if (this.customModules[i].id === id) { idx = i; break; } }
    if (idx === -1) return;
    var targetIdx = idx + dir;
    if (targetIdx < 0 || targetIdx >= this.customModules.length) return;
    var temp = this.customModules[idx];
    this.customModules[idx] = this.customModules[targetIdx];
    this.customModules[targetIdx] = temp;
    this.onCustomChange();
  };

  SofaConfigurator.prototype.onCustomChange = function() {
    this.renderModulePalette();
    this.renderBuildStrip();
    this.renderCustomPreview();
    this.validateCustomBuild();
    this.updateGallery();
    this.updateSummary();
  };

  SofaConfigurator.prototype.renderBuildStrip = function() {
    var self = this;
    var el = document.getElementById('BuildStrip-' + this.sectionId);
    if (!el) return;
    if (!this.customModules.length) {
      el.innerHTML = '<div class="custom-builder__strip-empty">Click "+ Add" above to start building your sofa</div>';
      return;
    }
    var html = '<div class="custom-builder__strip-label">Your Modules</div>';
    html += '<div class="custom-builder__strip-list">';
    this.customModules.forEach(function(mod, i) {
      var modDef = CUSTOM_MODULES.find(function(d) { return d.type === mod.type; });
      var label = modDef ? modDef.label : mod.type;
      var price = self.getModulePrice(mod.type);
      html += '<div class="custom-builder__strip-item" data-id="' + mod.id + '">';
      html += '<span class="custom-builder__strip-num">' + (i + 1) + '</span>';
      html += '<span class="custom-builder__strip-name">' + label + '</span>';
      if (price !== null) html += '<span class="custom-builder__strip-price">' + formatMoney(price, self.data.moneyFormat) + '</span>';
      html += '<span class="custom-builder__strip-controls">';
      html += '<button class="custom-builder__strip-btn" data-action="up" data-id="' + mod.id + '" type="button"' + (i === 0 ? ' disabled' : '') + ' aria-label="Move up">\u25B2</button>';
      html += '<button class="custom-builder__strip-btn" data-action="down" data-id="' + mod.id + '" type="button"' + (i === self.customModules.length - 1 ? ' disabled' : '') + ' aria-label="Move down">\u25BC</button>';
      html += '<button class="custom-builder__strip-btn custom-builder__strip-btn--remove" data-action="remove" data-id="' + mod.id + '" type="button" aria-label="Remove">\u00D7</button>';
      html += '</span>';
      html += '</div>';
    });
    html += '</div>';
    el.innerHTML = html;

    el.querySelectorAll('.custom-builder__strip-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var action = btn.dataset.action;
        var id = btn.dataset.id;
        if (action === 'up') self.moveCustomModule(id, -1);
        else if (action === 'down') self.moveCustomModule(id, 1);
        else if (action === 'remove') self.removeCustomModule(id);
      });
    });
  };

  /* ---------- Custom Builder: SVG Auto-Layout ---------- */

  SofaConfigurator.prototype.computeCustomSVGLayout = function() {
    var modules = this.customModules;
    if (!modules.length) return null;

    var SCALE = { '1 Seater': { w: 65, h: 65 }, '2 Seater': { w: 120, h: 65 }, '3 Seater': { w: 160, h: 65 }, '45\u00b0 Round Corner': { w: 65, h: 65 }, '90\u00b0 Square Corner': { w: 65, h: 65 }, '90\u00b0 Round Corner': { w: 65, h: 65 }, 'Footstool': { w: 50, h: 50 } };
    var GAP = 6;
    // 0=RIGHT, 1=DOWN, 2=LEFT, 3=UP
    var dirIdx = 0;
    var cx = 0, cy = 0;
    var rects = [];
    var footstoolRect = null;
    var lastRect = null;

    for (var i = 0; i < modules.length; i++) {
      var mod = modules[i];
      var s = SCALE[mod.type] || { w: 65, h: 65 };
      var isCorner = mod.type.indexOf('Corner') !== -1;
      var isFootstool = mod.type === 'Footstool';
      var isRound = mod.type === '90\u00b0 Round Corner';

      if (isFootstool) {
        if (lastRect) {
          footstoolRect = { x: lastRect.x, y: lastRect.y + lastRect.h + GAP, w: s.w, h: s.h, type: mod.type, isFootstool: true };
        } else {
          footstoolRect = { x: cx, y: cy, w: s.w, h: s.h, type: mod.type, isFootstool: true };
        }
        continue;
      }

      // Swap w/h when direction is vertical (pieces rotate with the layout)
      var pw, ph;
      if (dirIdx === 1 || dirIdx === 3) { pw = s.h; ph = s.w; }
      else { pw = s.w; ph = s.h; }

      // For LEFT/UP, offset placement so piece extends backward from cursor
      var px = cx, py = cy;
      if (dirIdx === 2) px = cx - pw;
      if (dirIdx === 3) py = cy - ph;

      var rect = { x: px, y: py, w: pw, h: ph, type: mod.type, isCorner: isCorner, isRound: isRound };
      rects.push(rect);
      lastRect = rect;

      if (isCorner) {
        // Turn direction 90° counter-clockwise FIRST, then advance cursor in NEW direction
        dirIdx = (dirIdx + 3) % 4;
        if (dirIdx === 0) { cx = px + pw + GAP; cy = py; }
        else if (dirIdx === 1) { cx = px; cy = py + ph + GAP; }
        else if (dirIdx === 2) { cx = px - GAP; cy = py; }
        else if (dirIdx === 3) { cx = px; cy = py - GAP; }
      } else {
        // Advance cursor in current direction
        if (dirIdx === 0) { cx = px + pw + GAP; }
        else if (dirIdx === 1) { cy = py + ph + GAP; }
        else if (dirIdx === 2) { cx = px - GAP; }
        else if (dirIdx === 3) { cy = py - GAP; }
      }
    }

    if (footstoolRect) rects.push(footstoolRect);

    // Normalize to (0,0) origin
    var minX = Infinity, minY = Infinity;
    rects.forEach(function(r) { if (r.x < minX) minX = r.x; if (r.y < minY) minY = r.y; });
    rects.forEach(function(r) { r.x -= minX; r.y -= minY; });

    var maxX = 0, maxY = 0;
    rects.forEach(function(r) { if (r.x + r.w > maxX) maxX = r.x + r.w; if (r.y + r.h > maxY) maxY = r.y + r.h; });

    return { rects: rects, vw: maxX, vh: maxY };
  };

  SofaConfigurator.prototype.renderCustomSVG = function(data) {
    if (!data || !data.rects.length) return '';
    var pad = 8;
    var vw = data.vw + pad * 2;
    var vh = data.vh + pad * 2;
    var els = data.rects.map(function(r) {
      var rx = r.x + pad;
      var ry = r.y + pad;
      if (r.isCorner && r.isRound) {
        var d = 'M ' + rx + ',' + ry + ' L ' + (rx + r.w) + ',' + ry + ' A ' + r.w + ',' + r.h + ' 0 0,1 ' + rx + ',' + (ry + r.h) + ' Z';
        return '<path d="' + d + '" fill="none" stroke="#333" stroke-width="1.5"/>';
      }
      var cr = r.isFootstool ? 2 : 3;
      var dash = r.isFootstool ? ' stroke-dasharray="4 2"' : '';
      return '<rect x="' + rx + '" y="' + ry + '" width="' + r.w + '" height="' + r.h + '" rx="' + cr + '" fill="none" stroke="#333" stroke-width="1.5"' + dash + '/>';
    }).join('');
    return '<svg viewBox="0 0 ' + vw + ' ' + vh + '" xmlns="http://www.w3.org/2000/svg">' + els + '</svg>';
  };

  SofaConfigurator.prototype.renderCustomPreview = function() {
    var el = document.getElementById('CustomPreview-' + this.sectionId);
    if (!el) return;
    if (!this.customModules.length) { el.innerHTML = ''; return; }
    var data = this.computeCustomSVGLayout();
    if (!data) { el.innerHTML = ''; return; }
    el.innerHTML = '<div class="custom-builder__preview-inner">' + this.renderCustomSVG(data) + '</div>';
  };

  /* ---------- Custom Builder: Validation ---------- */

  SofaConfigurator.prototype.validateCustomBuild = function() {
    var el = document.getElementById('CustomWarnings-' + this.sectionId);
    if (!el) return;
    if (!this.customModules.length) { el.innerHTML = ''; return; }

    var warnings = [];
    var corners = this.customModules.filter(function(m) { return m.type.indexOf('Corner') !== -1; });
    var footstools = this.customModules.filter(function(m) { return m.type === 'Footstool'; });

    if (corners.length > 2) warnings.push('Maximum 2 corner pieces allowed.');
    if (footstools.length > 1) warnings.push('Maximum 1 footstool allowed.');
    if (this.customModules.length > 8) warnings.push('Maximum 8 modules total.');

    // Corner at edges warning
    if (corners.length > 0) {
      var first = this.customModules[0];
      var last = this.customModules[this.customModules.length - 1];
      if (first.type.indexOf('Corner') !== -1 || last.type.indexOf('Corner') !== -1) {
        warnings.push('Corner piece at the edge may look unusual. Consider placing it between seaters.');
      }
    }

    // Footprint warning
    var layout = this.getCustomLayout();
    if (layout) {
      var fp = this.calculateFootprint(layout);
      if (fp && (fp.w_in > 150 || fp.d_in > 150)) {
        warnings.push('Total footprint exceeds 150\u2033 \u2014 make sure this fits your space.');
      }
    }

    // Color availability
    if (this.selectedColor) {
      var self = this;
      var unavailable = this.customModules.some(function(m) {
        if (m.type === 'Footstool') return !self.getFootstoolVariant(self.selectedColor);
        var v = self.getVariant(self.selectedColor, m.type);
        return !v || !v.available;
      });
      if (unavailable) warnings.push('Selected color is unavailable for one or more modules.');
    }

    if (!warnings.length) { el.innerHTML = ''; return; }
    var html = '';
    warnings.forEach(function(w) {
      html += '<div class="custom-builder__warning">';
      html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/></svg>';
      html += '<span>' + w + '</span></div>';
    });
    el.innerHTML = html;
  };

  /* ---------- Custom Builder: Synthetic Layout ---------- */

  SofaConfigurator.prototype.getCustomLayout = function() {
    if (!this.customModules.length) return null;
    var mods = this.customModules.map(function(m) { return m.type; });
    var corners = mods.filter(function(m) { return m.indexOf('Corner') !== -1; });
    var hasFootstool = mods.indexOf('Footstool') !== -1;
    var seats = 0;
    mods.forEach(function(m) {
      if (m === '1 Seater') seats += 1;
      else if (m === '2 Seater') seats += 2;
      else if (m === '3 Seater') seats += 3;
    });
    var cornerType = null;
    if (corners.length) cornerType = corners[0].indexOf('Round') !== -1 ? 'round' : 'square';

    var shapeKey;
    if (corners.length === 0) shapeKey = 'straight';
    else if (corners.length === 1) shapeKey = 'l-custom';
    else shapeKey = 'u-custom';

    return {
      id: 'custom',
      name: 'Custom Build',
      seats: seats,
      cornerType: cornerType,
      modules: mods,
      hasFootstool: hasFootstool,
      shapeKey: shapeKey
    };
  };

  /* ---------- Add to Cart ---------- */

  SofaConfigurator.prototype.addToCart = function() {
    var self = this;
    var layout = this.getSelectedLayout();
    if (!layout || !this.selectedColor) return;

    var addBtn = document.getElementById('AddToCart-' + this.sectionId);
    if (addBtn) { addBtn.classList.add('is-loading'); addBtn.textContent = 'Adding to Cart\u2026'; addBtn.disabled = true; }

    var itemMap = {}, valid = true;
    layout.modules.forEach(function(mod) {
      var variant;
      if (mod === 'Footstool') variant = self.getFootstoolVariant(self.selectedColor);
      else variant = self.getVariant(self.selectedColor, mod);
      if (!variant) { valid = false; return; }
      if (itemMap[variant.id]) itemMap[variant.id].quantity += 1;
      else itemMap[variant.id] = { id: variant.id, quantity: 1 };
    });

    if (!valid) {
      if (addBtn) { addBtn.classList.remove('is-loading'); addBtn.textContent = 'Configuration unavailable'; addBtn.disabled = false; }
      return;
    }

    var items = Object.keys(itemMap).map(function(k) { return itemMap[k]; });
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
    .then(function(res) { if (!res.ok) throw new Error('Cart add failed'); return res.json(); })
    .then(function() { window.location.href = '/cart'; })
    .catch(function(err) {
      console.error('Sofa configurator cart error:', err);
      if (addBtn) { addBtn.classList.remove('is-loading'); addBtn.textContent = 'Error \u2014 Please Try Again'; addBtn.disabled = false;
        setTimeout(function() { addBtn.textContent = 'Add Configuration to Cart'; }, 3000);
      }
    });
  };

  /* ---------- Auto-initialize ---------- */

  function initAll() {
    document.querySelectorAll('.sofa-configurator').forEach(function(el) {
      var sid = el.dataset.sectionId;
      if (sid && !el._configuratorInit) { el._configuratorInit = true; new SofaConfigurator(sid); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

})();
